//export const API_URL = "https://service.cliftoncobbler.com";
//export const API_URL = "https://localhost:8074";
export const API_URL = "https://cyyiqw6wc2.execute-api.eu-west-2.amazonaws.com/Prod"
//export const API_URL = "https://service.computerdevelopment.co.uk";
